module.exports = __webpack_public_path__ + "img/H5_bg@3x.c354aa35.png";